import { create, show, useModal } from "@ebay/nice-modal-react";
import { useState } from "react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type AssistantPanelLearnCancelConfirmationModalProps = {
  guideTitle: string;
  onConfirm: () => Promise<void>;
};

const AssistantPanelLearnCancelConfirmationModal = create(
  function AssistantPanelLearnCancelConfirmationModal({
    guideTitle,
    onConfirm,
  }: AssistantPanelLearnCancelConfirmationModalProps) {
    const modal = useModal();
    const [isLoading, setIsLoading] = useState(false);

    const handleOnConfirm = async () => {
      setIsLoading(true);
      try {
        await onConfirm();
        modal.resolve();
        modal.hide();
      } finally {
        setIsLoading(false);
      }
    };

    return (
      <ConfirmationModal
        title="Cancel objective?"
        confirmationButtonLabel="Cancel objective"
        confirmationButtonVariant="dangerPrimary"
        onConfirm={handleOnConfirm}
        isLoading={isLoading}
        isConfirmationDisabled={isLoading}
      >
        <ConfirmationModalMessage>
          Your progress on <strong>{guideTitle}</strong> will be lost.
        </ConfirmationModalMessage>
      </ConfirmationModal>
    );
  }
);

export const showAssistantPanelLearnCancelConfirmationModal = (
  props: AssistantPanelLearnCancelConfirmationModalProps
) => show(AssistantPanelLearnCancelConfirmationModal, props);
